import { render, staticRenderFns } from "./VideoChunckGenerator.vue?vue&type=template&id=0f6567c3&scoped=true"
import script from "./VideoChunckGenerator.vue?vue&type=script&lang=ts"
export * from "./VideoChunckGenerator.vue?vue&type=script&lang=ts"
import style0 from "./VideoChunckGenerator.vue?vue&type=style&index=0&id=0f6567c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6567c3",
  null
  
)

export default component.exports